import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Header } from '../header/header';
import { LayoutService } from '../layout.service';
import { Sidebar } from '../sidebar/sidebar';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, Sidebar, Header, RouterOutlet, ToastModule],
  template: `
    <div class="layout">
      <app-sidebar></app-sidebar>
      <div class="layout-main">
        <app-header></app-header>
        <main class="layout-content">
          <router-outlet></router-outlet>
        </main>
      </div>
      <p-toast position="bottom-right"></p-toast>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100vh;
      }

      .layout {
        display: flex;
        height: 100vh;
        background: var(--color-bg);
      }

      .layout-main {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 0;
        background: var(--color-bg);
      }

      .layout-content {
        flex: 1;
        overflow-y: auto;
        padding: var(--space-6);
      }
    `,
  ],
})
export class Layout {
  layoutService = inject(LayoutService);
}
